//@flow
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { branch, renderNothing } from "recompose";

import { withI18n, Translate } from "@quantum/i18n";

import { compose } from "ramda";

import SelecaoAjusteDias from "../ajusteDias/SelecaoAjusteDias";
import SelectInput from "../../../comum/SelectInput";
import { SelecaoToleranciaDF } from "../../../edicaoMedidas/configuracoes";
import SelecaoTipoCalculo from "./indicadoresFinanceiros/SelecaoTipoCalculo";
import SelecaoComparacaoAnaliseHorizontal from "./indicadoresFinanceiros/SelecaoComparacaoAnaliseHorizontal";
import SelecaoFrequencia from "./indicadoresFinanceiros/SelecaoFrequencia";
import {
  type Id,
  type MedidaSelecionada,
  type ErrosSelecao,
  ID_AJUSTE_DIAS_NORMAL,
  ID_PERIODO_ANO_A_ANO,
  ID_PERIODO_DATAS_REFERENCIA,
  ID_PERIODO_ANALISE_HORIZONTAL,
  ID_TIPO_REFERENCIA_EDITAVEL,
  MAP_ID_AJUSTE_DIAS_TIPO_DATA_REFERENCIA_INDICADORES_FINANCEIROS,
  ID_TIPO_CALCULO_PONTUAL,
  ID_TIPO_CALCULO_VARIACAO_PERCENTUAL,
  GRUPAMENTO_MEDIDAS_EMPRESAS,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_DATA_REFERENCIA_TRIMESTRE,
} from "../../../../model";
import {
  type State,
  type ActionCreator,
  type ProcessadorPeriodo,
  getAnosSelecionados,
  selecionarAnos,
  getAnos,
  getComparacaoSelecionada,
  getFrequenciasSelecionadas,
  selecionarFrequencias,
  getIsIndicadorFinanceiroSelecionado,
  getAjusteDiasSelecionado,
  selecionarPeriodo,
  selecionarTipoCalculo,
  getTipoCalculoSelecionado,
  selecionarAjusteDias,
  getIndiceMedidaEditada,
  isSomenteAnoETrimestreBaseEmpresasAbertasSelecionados,
  getGrupamentoMedidaSelecionado,
  isModoSeries,
  getIdMedidaSelecionada,
  i18n,
  getAdicionarDataReferencia,
  getMedidaSelecionadaPorIdConfiguracaoRelatorio,
} from "../../../../state";

import { comEdicaoDeMedida } from "../../Contexto";
import CheckboxDataReferencia from "./CheckboxDataReferencia/CheckboxDataReferencia";

type Props = {
  listaAnos: Array<Id>,
  anosSelecionados: Array<Id>,
  selecionarAnos: ActionCreator,
  selecionarFrequencias: ActionCreator,
  ajusteDiasSelecionado: ?Id,
  selecionarAjusteDias: ActionCreator,
  selecionarPeriodo: ActionCreator,
  exibirTipoCalculo: boolean,
  tipoCalculoSelecionado: ?Id,
  selecionarTipoCalculo: ActionCreator,
  indiceMedidaEditada: ?number,
  isSomenteAnoETrimestreBaseEmpresasAbertasSelecionados: boolean,
  grupamentoMedidaSelecionado: string,
  desmarcarTodosAnos: ActionCreator,
  idMedidaSelecionada: ?Id,
};

function SelecaoPeriodoIndicadoresFinanceiros({
  listaAnos,
  anosSelecionados,
  selecionarAnos,
  selecionarFrequencias,
  ajusteDiasSelecionado,
  selecionarAjusteDias,
  selecionarPeriodo,
  exibirTipoCalculo = false,
  tipoCalculoSelecionado,
  selecionarTipoCalculo,
  indiceMedidaEditada,
  isSomenteAnoETrimestreBaseEmpresasAbertasSelecionados,
  grupamentoMedidaSelecionado,
  desmarcarTodosAnos,
  idMedidaSelecionada,
}: Props) {
  useEffect(() => {
    if (
      tipoCalculoSelecionado === ID_TIPO_CALCULO_PONTUAL &&
      grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_EMPRESAS
    ) {
      ajusteDiasSelecionado === ID_AJUSTE_DIAS_NORMAL
        ? selecionarPeriodo([ID_PERIODO_ANO_A_ANO])
        : selecionarPeriodo([ID_PERIODO_DATAS_REFERENCIA]);
    } else if (
      tipoCalculoSelecionado === ID_TIPO_CALCULO_VARIACAO_PERCENTUAL &&
      grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_EMPRESAS
    ) {
      selecionarPeriodo([ID_PERIODO_ANALISE_HORIZONTAL]);
    }
  }, [
    anosSelecionados,
    selecionarFrequencias,
    ajusteDiasSelecionado,
    tipoCalculoSelecionado,
    grupamentoMedidaSelecionado,
    selecionarPeriodo,
  ]);

  useEffect(() => {
    if (
      anosSelecionados.length > 1 &&
      grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_EMPRESAS
    ) {
      selecionarTipoCalculo(ID_TIPO_CALCULO_PONTUAL);
    }
  }, [
    anosSelecionados,
    grupamentoMedidaSelecionado,
    selecionarTipoCalculo,
    selecionarAjusteDias,
  ]);

  useEffect(() => {
    if (
      !indiceMedidaEditada &&
      !isSomenteAnoETrimestreBaseEmpresasAbertasSelecionados &&
      grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_EMPRESAS
    ) {
      selecionarAjusteDias(ID_AJUSTE_DIAS_NORMAL);
    }
  }, [
    idMedidaSelecionada,
    indiceMedidaEditada,
    isSomenteAnoETrimestreBaseEmpresasAbertasSelecionados,
    grupamentoMedidaSelecionado,
    selecionarAjusteDias,
  ]);

  return (
    <>
      <div className="ConfiguracaoMedida">
        <label className="ConfiguracaoMedida__label">
          <Translate>maiusculas.periodo</Translate>
          {anosSelecionados.length >= 1 && (
            <span
              className="ConfiguracaoMedida__label--desmarcar"
              onClick={desmarcarTodosAnos}
            >
              <Translate>Comum.desmarcarTodos</Translate>
            </span>
          )}
        </label>
        <SelectInput
          onChange={selecionarAnos}
          value={anosSelecionados}
          options={listaAnos}
          size={10}
          multiple={true}
          campoId={"codigo"}
          campoDescricao={"descricao"}
        />
      </div>
      <div className="ConfiguracaoMedida__box">
        {exibirTipoCalculo ? (
          <div className="ConfiguracaoMedida__box">
            <SelecaoTipoCalculo />
          </div>
        ) : null}
        <div className="ConfiguracaoMedida__box">
          <SelecaoToleranciaDF />
        </div>
        <div className="ConfiguracaoMedida__box">
          <SelecaoFrequencia />
        </div>
        <div className="ConfiguracaoMedida__box">
          <div className="ConfiguracaoMedida">
            <SelecaoAjusteDias />
          </div>
        </div>
        {tipoCalculoSelecionado === ID_TIPO_CALCULO_VARIACAO_PERCENTUAL ? (
          <div className="ConfiguracaoMedida__box">
            <div className="ConfiguracaoMedida">
              <SelecaoComparacaoAnaliseHorizontal />
            </div>
          </div>
        ) : null}
        <div className="ConfiguracaoMedida__box">
          <div className="ConfiguracaoMedida">
            <CheckboxDataReferencia />
          </div>
        </div>
      </div>
    </>
  );
}

const processarAnosEFrequencias = (
  state: State,
  medidasSelecionadas: Array<MedidaSelecionada>,
  processador: any
) => {
  const adicionarDataReferencia = getAdicionarDataReferencia(state);
  const medidaDataReferencia = adicionarDataReferencia
    ? getMedidaSelecionadaPorIdConfiguracaoRelatorio(
        state,
        ID_CONFIGURACAO_RELATORIO_MEDIDA_DATA_REFERENCIA_TRIMESTRE
      )
    : null;

  const anosSelecionados: Array<Id> = getAnosSelecionados(state) || [];
  const frequenciasSelecionadas: Array<Id> =
    getFrequenciasSelecionadas(state) || [];
  const _medidasSelecionadas = [];

  medidasSelecionadas.forEach(medidaSelecionada => {
    anosSelecionados.forEach(ano => {
      frequenciasSelecionadas.forEach(frequencia => {
        _medidasSelecionadas.push(
          processador(medidaSelecionada, ano, frequencia)
        );
        if (medidaDataReferencia) {
          _medidasSelecionadas.push({
            ...medidaDataReferencia,
            ano,
            frequencia,
            ajusteDias: ID_AJUSTE_DIAS_NORMAL,
            periodo: ID_PERIODO_ANO_A_ANO,
          });
        }
      });
    });
  });

  return _medidasSelecionadas;
};

export const processarPeriodoAnoAAno: ProcessadorPeriodo = (
  periodo: Id,
  state: State,
  medidasSelecionadas: Array<MedidaSelecionada>
) => {
  const processadorAnoAAno = (medidaSelecionada, ano, frequencia) => {
    return { ...medidaSelecionada, periodo, ano, frequencia };
  };

  return processarAnosEFrequencias(
    state,
    medidasSelecionadas,
    processadorAnoAAno
  );
};

export const processarPeriodoDatasIndicadoresFinanceiros: ProcessadorPeriodo = (
  periodo: Id,
  state: State,
  medidasSelecionadas: Array<MedidaSelecionada>
) => {
  const ajusteDias: ?Id = getAjusteDiasSelecionado(state);

  const processadorDatasIndicadoresFinanceiros = (
    medidaSelecionada,
    ano,
    frequencia
  ) => {
    return {
      ...medidaSelecionada,
      periodo,
      tipoReferencia: ID_TIPO_REFERENCIA_EDITAVEL,
      anoReferencia: ano,
      trimestreReferencia: frequencia,
      dataReferencia:
        ajusteDias &&
        MAP_ID_AJUSTE_DIAS_TIPO_DATA_REFERENCIA_INDICADORES_FINANCEIROS[
          ajusteDias
        ],
    };
  };

  return processarAnosEFrequencias(
    state,
    medidasSelecionadas,
    processadorDatasIndicadoresFinanceiros
  );
};

export const processarPeriodoAnaliseHorizontal: ProcessadorPeriodo = (
  periodo: Id,
  state: State,
  medidasSelecionadas: Array<MedidaSelecionada>
) => {
  const comparacao: ?Id = getComparacaoSelecionada(state);

  const processadorAnaliseHorizontal = (medidaSelecionada, ano, frequencia) => {
    return {
      ...medidaSelecionada,
      periodo,
      tipoReferencia: ID_TIPO_REFERENCIA_EDITAVEL,
      anoReferencia: ano,
      trimestreReferencia: frequencia,
      dataReferencia: comparacao,
    };
  };

  return processarAnosEFrequencias(
    state,
    medidasSelecionadas,
    processadorAnaliseHorizontal
  );
};

export const criarFuncaoValidacaoSelecaoPeriodoIndicadoresFinanceiros = (
  state: State
) => () => {
  if (!getIsIndicadorFinanceiroSelecionado(state)) {
    return null;
  }

  const { translate } = i18n(state);

  const errosSelecaoPeriodo: ErrosSelecao = {};
  const anosSelecionados: ?Array<Id> = getAnosSelecionados(state);
  const frequenciasSelecionadas: ?Array<Id> = getFrequenciasSelecionadas(state);

  if (!isModoSeries && (!anosSelecionados || anosSelecionados.length) === 0) {
    errosSelecaoPeriodo.periodoNaoSelecionado = translate(
      "Periodo.Msg.ErroPeriodoNaoSelecionado"
    );
  }
  if (!frequenciasSelecionadas || frequenciasSelecionadas.length === 0) {
    errosSelecaoPeriodo.frequenciaNaoSelecionada = translate(
      "Periodo.Msg.ErroFrequenciaNaoSelecionada"
    );
  }

  return Object.keys(errosSelecaoPeriodo).length === 0
    ? null
    : errosSelecaoPeriodo;
};

export default compose(
  withI18n,
  comEdicaoDeMedida,
  branch(({ exibirSelecaoPeriodo }) => !exibirSelecaoPeriodo, renderNothing),
  connect(
    (state, ownProps) => ({
      listaAnos: getAnos(state),
      idMedidaSelecionada: getIdMedidaSelecionada(state),
      anosSelecionados: getAnosSelecionados(state),
      ajusteDiasSelecionado: getAjusteDiasSelecionado(state),
      tipoCalculoSelecionado: getTipoCalculoSelecionado(state),
      indiceMedidaEditada: getIndiceMedidaEditada(state),
      isSomenteAnoETrimestreBaseEmpresasAbertasSelecionados: isSomenteAnoETrimestreBaseEmpresasAbertasSelecionados(
        state
      ),
      grupamentoMedidaSelecionado: getGrupamentoMedidaSelecionado(state),
    }),
    {
      desmarcarTodosAnos: () => selecionarAnos([]),
      selecionarAnos,
      selecionarFrequencias,
      selecionarPeriodo,
      selecionarTipoCalculo,
      selecionarAjusteDias,
    }
  )
)(SelecaoPeriodoIndicadoresFinanceiros);
